module.exports = __webpack_public_path__ + "static/media/mobile_187x406.83b36306.png";